module.exports = __webpack_public_path__ + "img/57-1.d37d1a2a.png";